import { Box, Grid, Stack, Typography, styled } from "@mui/material";
import React from "react";
import StarIcon from "../icons/StarIcon";

const StyledBox = styled(Box)(({ theme }) => ({
  boxShadow: `0px 0px 15px rgba(169, 80, 82, 0.5)`,
  border: `1px solid ${theme.palette.divider}`,
  padding: "30px",
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  height: "100%",

  [theme.breakpoints.down("md")]: {
    height: "auto",
  },
}));

const data = [
  {
    id: 1,
    title: "60 +",
    description: "proyectos culminados",
    img: "/assets/about/plusval-estates.png",
  },
  {
    id: 2,
    title: "2,500 +",
    description: "clientes satisfechos",
    img: "/assets/about/plusval-estates.png",
  },
  {
    id: 3,
    title: "45 +",
    description: "premios y galardones",
    img: "/assets/about/plusval-estates.png",
  },
];
const Achievements = ({
  title = "Our Achievements",
  description = " Our story is one of continuous growth and evolution. We started as a small team with big dreams, determined to create a real estate platform that transcended the ordinary.",
  isCard = true,
}) => {
  return (
    <Stack py={4} mb={5}>
      <Box mb={2}>
        <StarIcon />
      </Box>
      <Typography variant="h3" color="text.secondary" mb={2}>
        {title}
      </Typography>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        width={{ xs: "100%", md: "60%" }}
        mb={5}
      >
        {description}
      </Typography>
      {isCard && (
        <Grid container spacing={3}>
          {data.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <StyledBox>
                <Typography variant="h2" color="text.secondary">
                  {item.title}
                </Typography>
                <Typography variant="h5" color="text.primary">
                  {item.description}
                </Typography>
              </StyledBox>
            </Grid>
          ))}
        </Grid>
      )}
    </Stack>
  );
};

export default Achievements;
